import GroupSelector from "./GroupSelector";
import {
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup
    } from "@mui/material";
import { GroupWithId } from "../../interfaces/IGroups";

interface ParticipantSourceSelectorProps {
  source: "participants" | "group";
  onSourceChange: (source: "participants" | "group") => void;
  disabled?: boolean;
  groups?: GroupWithId[];
  selectedGroupId?: string | null;
  onGroupChange?: (groupId: string | null) => void;
}

/**
 * Komponent do wyboru źródła zawodników (zawodnicy vs grupy)
 * Używa radio buttons do wyboru między dwiema opcjami
 */
export default function ParticipantSourceSelector({
  source,
  onSourceChange,
  disabled = false,
  groups = [],
  selectedGroupId = null,
  onGroupChange,
}: ParticipantSourceSelectorProps) {
  return (
    <FormControl component="fieldset" disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
        <FormLabel component="legend" sx={{ mb: 0, mr: 0 }}>
          Wybierz z:
        </FormLabel>
        <RadioGroup
          row
          value={source}
          onChange={(e) => onSourceChange(e.target.value as "participants" | "group")}
          sx={{ ml: 0 }}
        >
          <FormControlLabel
            value="participants"
            control={<Radio size="small" />}
            label="Zawodnicy"
          />
          <FormControlLabel value="group" control={<Radio size="small" />} label="Grupy" />
        </RadioGroup>
        {source === "group" && groups && (
          <Box sx={{ width: "200px" }}>
            <GroupSelector
              groups={groups}
              selectedGroupId={selectedGroupId}
              onGroupChange={onGroupChange || (() => {})}
              disabled={disabled}
            />
          </Box>
        )}
      </Box>
    </FormControl>
  );
}
